import MUITable from '@material-ui/core/Table';
import MUITableHead from '@material-ui/core/TableHead';
import MUITableBody from '@material-ui/core/TableBody';
import MUITableCell from '@material-ui/core/TableCell';
import MUITableRow from '@material-ui/core/TableRow';
import styled from 'styled-components';
import Color from 'color';

const Table = styled(MUITable)`
  & .MuiTableCell-root {
    ${props => props.theme.typography.body1};
    color: ${props => props.theme.colors.text.primary};
    border-bottom: 1px solid ${props => Color(props.theme.colors.text.primary).fade(0.83).string()};
  }
`;

const Header = styled(MUITableHead)`
  & .MuiTableCell-root {
    ${props => props.theme.typography.subtitle1};
    color: ${props => props.theme.colors.text.secondary};
  }
`;

Table.Body = MUITableBody;
Table.Cell = MUITableCell;
Table.Row = MUITableRow;
Table.Header = Header;

export default Table;
